import Backbone from 'backbone';

export default Backbone.View.extend({
    events: {},

    initialize: function () {
        // this.initKeyboardShortcuts();
    },

    onKeyOpenCategory: function (event) {
        event.preventDefault();

        const index = event.data.replace('alt+', '');
        const tabs = this.$el.children('li.category');

        if (tabs.eq(index - 1).length > 0) {
            window.location.href = tabs
                .eq(index - 1)
                .children('a')
                .attr('href');
        }
    }
});


// WEBPACK FOOTER //
// ./views/layout/CategoryMenuElementController.js